import { Blog, MenuType } from "@/types";
import { categoryDetails as category1 } from "@/content/services/1";
import { categoryDetails as category2 } from "@/content/services/2";

export const headerNavMenuData: MenuType[] = [
  { label: "Home", href: "/" },
  {
    label: "Services",
    href: "/services",
    children: [
      {
        heading: category1.name,
        headingUrl: `/${category1.categoryType}/${category1.slug}`,
        submenu:
          category1.subCategories?.map((service: Blog) => ({
            href: `/${category1.categoryType}/${category1.slug}/${service.slug}`,
            label: service.title,
          })) || [],
      },
      {
        heading: category2.name,
        headingUrl: `/${category2.categoryType}/${category2.slug}`,
        submenu:
          category2.subCategories?.map((service: Blog) => ({
            href: `/${category2.categoryType}/${category2.slug}/${service.slug}`,
            label: service.title,
          })) || [],
      },
    ],
  },
  { label: "Contact us", href: "/contact" },
  { label: "About", href: "/about" },
];
